<template>
  <div>
    <input v-model="searchText"
           style="font-size:12pt;"
           type="search"
           placeholder="search..."
           size="20"
           autocomplete="off"
           @click="searchText=' '"
           :disabled="review"/>
  </div>
</template>

<script>
import Fuse from 'fuse.js'

const SEARCH_OPTIONS = {
  isCaseSensitive: false,
  findAllMatches: false,
  includeMatches: false,
  includeScore: false,
  useExtendedSearch: false,
  minMatchCharLength: 1,
  shouldSort: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  keys: ['name', 'id']
}

export default {
  name: 'Search',
  props: ['productsToSearch', 'review'],
  emits: ['searchresults'],
  data: function () {
    return {
      searchText: '',
      searchProducts: [],
    }
  },
  watch: {
    productsToSearch: function (newVal) {
      this.searchProducts = newVal
    },
    searchText: function (text) {
      let searchResults = this.productsToSearch
      if (text.trim().length > 0) {
        let results = new Fuse(this.productsToSearch, SEARCH_OPTIONS).search(text.trim())
        if (results.length > 0) {
          searchResults = []
          for (const result of results) {
            searchResults.push(result.item)
          }
        }
      }
      this.$emit('searchresults', searchResults)
    },
  },
}
</script>